import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingTT } from '../constants/constants';

@Pipe({ name: 'colorMappingTT' })
export class ColorMappingTTPipe implements PipeTransform {
  transform(value: number, greenTableDesign: boolean) {
    return colorMappingTT(value, greenTableDesign);
  }
}
